<template>
<svg data-svg-lvl-3="spread-block-spread" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><clipPath id="ls-cp"><rect class="ls-c-1" x="66.88" y="147.8" width="379.73" height="138.94" rx="12.01"/></clipPath></defs><g id="Разворот"><g class="ls-c-4"> <rect :style="{ fill: params.slice.color }"  class="ls-c-1" x="66.88" y="147.8" width="379.73" height="138.94" rx="12.01"/> <image width="1200" height="411" transform="translate(46.22 144.74) scale(0.35)" :href="params.blockImage"  v-show="params.blockImage" preserveAspectRatio="xMidYMid slice" /></g></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.ls-c-1{fill:none;}.ls-c-2{opacity:0.3;}.ls-c-3{fill:#64ff00;}.ls-c-4{clip-path:url(#ls-cp);}</style>

